/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchasedServicesResponse } from '../../models/purchased-services-response';

export interface GetPurchasedServices$Params {
}

export function getPurchasedServices(http: HttpClient, rootUrl: string, params?: GetPurchasedServices$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchasedServicesResponse>> {
  const rb = new RequestBuilder(rootUrl, getPurchasedServices.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchasedServicesResponse>;
    })
  );
}

getPurchasedServices.PATH = '/api/ambassador-enabling-services/purchased';
